<% if (login_type == 'mychart') { %>
  <%= renderPartial('appointment_booking/wizard/templates/step/patient/mychart', {
    patient_id: patient_id,
    mychart_login_error: mychart_login_error,
    appointment_slot: appointment_slot,
    email: email
  }) %>
<% } else { %>
  <%= renderPartial('appointment_booking/wizard/templates/step/patient/guest', {
    pcp_id: pcp_id,
    first_name: first_name,
    last_name: last_name,
    date_of_birth: date_of_birth,
    last_4_ssn: last_4_ssn,
    gender: gender,
    email: email,
    marketing_opt_in: obj.marketing_opt_in, // Only some clients define the attribute, and a bare local raises a ReferenceError where it is absent.
    available_phone_types: available_phone_types,
    primary_phone: primary_phone,
    primary_phone_type: primary_phone_type,
    secondary_phone: secondary_phone,
    secondary_phone_type: secondary_phone_type,
    street: street,
    street_line2: street_line2,
    city: city,
    zip_code: zip_code,
    state: state,
    appointment_slot: appointment_slot
  }) %>
<% } %>
